import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo, useState } from "react";
import InfiniteCalendar from "react-infinite-calendar";
import getDateFnsLocale from "../../utils/functions/dateFns";
import DatePickerMobileModal from "../DatePickerMobileModal";
const DatePickerMobile = forwardRef(({ mobileTitleLabel, mobileSubTitleLabel, confirmDateLabel, resetDateLabel, value, placeholder = "Check-in", localeLang, localeMobileConfig, formatDateOptions, minDate, maxDate, disabledDates, disabledDays, onReset, onClose, onConfirm, }, ref) => {
    const [currentDate, setCurrentDate] = useState(value ? value.toJSDate() : undefined);
    const [date, setDate] = useState(value ? value.toJSDate() : undefined);
    const [isOpen, setIsOpen] = useState(false);
    const localeConfig = useMemo(() => getDateFnsLocale(localeLang, localeMobileConfig), [localeLang, localeMobileConfig]);
    const handleOnReset = () => {
        setCurrentDate(undefined);
        if (onReset) {
            onReset();
        }
    };
    const handleOnClose = () => {
        setCurrentDate(date);
        if (onClose) {
            onClose();
        }
        setIsOpen(false);
    };
    const handleOnConfirm = () => {
        setDate(currentDate);
        if (onConfirm) {
            onConfirm(currentDate);
        }
        setIsOpen(false);
    };
    const handleOnSelect = (dateSelected) => {
        setCurrentDate(dateSelected);
    };
    return (_jsx(DatePickerMobileModal, { value: currentDate, isOpen: isOpen, onDateClick: () => setIsOpen(true), onConfirm: handleOnConfirm, onReset: handleOnReset, onClose: handleOnClose, localeLang: localeLang, placeholder: placeholder, formatDateOptions: formatDateOptions, title: mobileTitleLabel, subTitle: mobileSubTitleLabel, confirmLabel: confirmDateLabel, resetLabel: resetDateLabel, children: _jsx(InfiniteCalendar, { ref: ref, selected: currentDate !== null && currentDate !== void 0 ? currentDate : false, onSelect: handleOnSelect, width: window.innerWidth, height: window.innerHeight, displayOptions: { showMonthsForYears: false }, disabledDays: disabledDays, disabledDates: disabledDates, locale: localeConfig, minDate: minDate, maxDate: maxDate }) }));
});
export default DatePickerMobile;
